type GetCurrentDayType = () => string;

export const getCurrentDay: GetCurrentDayType = () => {
  const today = new Date();

  return today.toLocaleDateString('en-GB', {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
};
